import { render, staticRenderFns } from "./GExhibitionOfflineBrands.vue?vue&type=template&id=76de825f&scoped=true&"
import script from "./GExhibitionOfflineBrands.vue?vue&type=script&lang=ts&"
export * from "./GExhibitionOfflineBrands.vue?vue&type=script&lang=ts&"
import style0 from "./GExhibitionOfflineBrands.vue?vue&type=style&index=0&id=76de825f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76de825f",
  null
  
)

export default component.exports